import React, { useEffect, useState } from "react";
import { AppInitApi } from "../lib/api/AppInitApi";

import { Alert } from "../lib/alert";

const CompanyLayer = () => {
  const [company, setCompany] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const [appVersion, setAppVersion] = useState("");
  // Ganti dengan versi aplikasi yang sesuai

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await AppInitApi.show(); // Sesuaikan dengan API yang kamu gunakan
        if (response.error_code !== 200) {
          throw new Error(response.message);
        }

        console.log("Company data fetched successfully:", response.data);
        setCompany(response.data); // atau sesuaikan dengan struktur responsmu
        setAppVersion(response.data.version); // Set initial version from fetched data
        setLoading(false);
      } catch (error) {
        setErrorMsg("Gagal mengambil data sales.");
        setLoading(false);
      }
    };

    fetchCompany();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log("Submitting company data:", {
    //   version: appVersion,
    // });
    // return;
    try {
      const response = await AppInitApi.update({ version: appVersion });
      if (response.error_code !== 201) {
        throw new Error(response.message);
      }
      console.log("Company data updated successfully:", response.data);
      Alert.success("Data perusahaan berhasil diperbarui.");
      setCompany(response.data); // Update state with the new company data
    } catch (error) {
      setErrorMsg("Gagal memperbarui data perusahaan.");
    }
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden">
      <div className="card-body p-40">
        <form onSubmit={handleSubmit} className="form">
          <div className="row">
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Full Name <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="name"
                  placeholder="Enter Full Name"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="version"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Version <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="version"
                  value={appVersion ? appVersion : "-"}
                  onChange={(e) => setAppVersion(e.target.value)}
                  placeholder={company.version}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="number"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Phone Number
                </label>
                <input
                  type="email"
                  className="form-control radius-8"
                  id="number"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="Website"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  {" "}
                  Website
                </label>
                <input
                  type="url"
                  className="form-control radius-8"
                  id="Website"
                  placeholder="Website URL"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="country"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Country <span className="text-danger-600">*</span>{" "}
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="country"
                  defaultValue="Select Country"
                >
                  <option value="Select Country" disabled>
                    Select Country
                  </option>
                  <option value="USA">USA</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="India">India</option>
                  <option value="Canada">Canada</option>
                </select>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="city"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  City <span className="text-danger-600">*</span>{" "}
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="city"
                  defaultValue="Select City"
                >
                  <option value="Select City" disabled>
                    Select City
                  </option>
                  <option value="Washington">Washington</option>
                  <option value="Dhaka">Dhaka</option>
                  <option value="Lahore">Lahore</option>
                  <option value="Panjab">Panjab</option>
                </select>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="state"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  State <span className="text-danger-600">*</span>{" "}
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="state"
                  defaultValue="Select State"
                >
                  <option value="Select State" disabled>
                    Select State
                  </option>
                  <option value="Washington">Washington</option>
                  <option value="Dhaka">Dhaka</option>
                  <option value="Lahore">Lahore</option>
                  <option value="Panjab">Panjab</option>
                </select>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-20">
                <label
                  htmlFor="zip"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  {" "}
                  Zip Code <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="zip"
                  placeholder="Zip Code"
                />
              </div>
            </div>
            <div className="col-sm-12">
              <div className="mb-20">
                <label
                  htmlFor="address"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  {" "}
                  Address* <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="address"
                  placeholder="Enter Your Address"
                />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
              <button
                type="submit"
                className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
              >
                Save Change
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyLayer;
